import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"

import Index from './Index/View'
import IndexAdmin from './Index/ViewAdmin'
import Create from './Create/View'
import Detail from './Detail/View'

const RouteView = (props) => {
    const { params } = props    
	const queryParams = new URLSearchParams(props.location.search);
    const _id = queryParams.get('id')
    const _uuid = queryParams.get('uuid')
    const _date = queryParams.get('date')
    const _create = queryParams.get('create')
    const _list = queryParams.get('list')
    const _detail = queryParams.get('detail')
    const _update = queryParams.get('update')
    const _delete = queryParams.get('delete')
    const _approve = queryParams.get('approve')
    const _print = queryParams.get('print')

    if (_create != null) {
    	return accessRole('create') ? <Create /> : <ErrorAccess />
    } else if (_detail != null) {
    	return accessRole('read') ? <Detail /> : <ErrorAccess />
    } else if (_update != null) {
    	return accessRole('update') ? null : <ErrorAccess />
    } else if (_list != null) {
    	return accessRole('read') ? null : <ErrorAccess />
    } else if (_delete != null) {
    	return null
    } else if (_approve != null) {
    	return accessRole('approve') ? null : <ErrorAccess />
    } else if (_print != null) {
    	return null
    }

    // Jika Admin
    if (accessRole('approve')) {
        return accessRole('read') ? <IndexAdmin /> : <ErrorAccess />
    } else {
        return accessRole('read') ? <Index /> : <ErrorAccess />
    }


}

export default RouteView